module.exports = __webpack_public_path__ + "static/media/Admin-3.820fd851.png";